import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import axios from "axios";
import CatalogoOrganizacion from "../../catalogos/catalogoOrganizacion";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import {
  validaSoloNumero,
  validaNumeroTelefono,
  validaEmail,
} from "../../util/varios";
import moment from "moment";
import { Dimmer } from "../spinner";
import {
  DangerButton,
  InfoButton,
  SuccessButton,
} from "../../ui/buttons/Button";
import { Checkbox, Input, Radio, SearchInput, Select, Textarea } from "../../ui/inputs/Input";
export const ActualizarUsuario = (props) => {
  const txtClaveSuper = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [contar, setContar] = useState(0);
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [modulos, setModulos] = useState({
    accrepgenseccat: "0",
    accrepdepreciacion: "0",
    accrepvalterreno: "0",
    accrepvalconstruc: "0",
    accrepconstancia: "0",
    accrepceremp: "0",
    accrepcedcat: "0",
    acccamstainmue: "0",
    accedocuenta: "0",
    accrenovalicencia: "0",
    acclicenciafunciona: "0",
    accpermdecla: "0",
    accacreditacion: "0",
    accexoncomercio: "0",
    accverifica: "0",
    accconfigcome: "0",
    accrepgensector: "0",
    accreppatente: "0",
    accrepactividad: "0",
    accrepfecdecla: "0",
    accrepmondecla: "0",
    accimppatente: "0",
    accimpedoctasectcome: "0",
    accimptramites: "0",
  });
  const [permisos, setPermisos] = useState({
    accvalortipocat: "0000",
    accfichacat: "0000",
    supercat: false,
    accavaluo: "0000",
    accdepreciacioncat: "0000",
    accvalorterrecat: "0000",
    accrepvalconstruc: "0000",
    accusuariocat: "0000",
    accactividad: "0000",
    accdeclaraciones: "000",
    accacticontri: "00",
    accagente: "0000",
    accusuariocome: "0000",
  });
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const txtIdUsuario = useRef();
  const txtLogin = useRef();
  const txtPassword = useRef();
  const txtConfirmPassword = useRef();
  const txtIdOrg = useRef();
  const txtNomOrg = useRef();
  const txtCedula = useRef();
  const txtNombreUsuario = useRef();
  const txtApellidoUsuario = useRef();
  const txtDireccionUsuario = useRef();
  const txtEmailUsuario = useRef();
  const txtTlfUsuario = useRef();
  const txtCelUsuario = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const chkLiquidador = useRef();
  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (props.operacion) {
      setOperacion(props.operacion);
    }
    if (op.reportes != null) {
    } else {
    }
  }, [props.operacion]);
  const procesarRegistro = (body) => {
    let endpoint = `${op.conexion}/api/comun/actualizarusuario/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let per = JSON.parse(localStorage.getItem("idusuario"));
          if (per === txtIdUsuario.current.value) {
            localStorage.setItem(
              "accrepvalterreno",
              JSON.stringify(modulos.accrepvalterreno)
            );
            localStorage.setItem(
              "accrepdepreciacion",
              JSON.stringify(modulos.accrepdepreciacion)
            );
            localStorage.setItem(
              "accrepgenseccat",
              JSON.stringify(modulos.accrepgenseccat)
            );
            localStorage.setItem(
              "accrepconstancia",
              JSON.stringify(modulos.accrepconstancia)
            );
            localStorage.setItem(
              "accrepvalconstruc",
              JSON.stringify(modulos.accrepvalconstruc)
            );
            localStorage.setItem(
              "acccamstainmue",
              JSON.stringify(modulos.acccamstainmue)
            );
            localStorage.setItem(
              "accrepcedcat",
              JSON.stringify(modulos.accrepcedcat)
            );
            localStorage.setItem(
              "accrepceremp",
              JSON.stringify(modulos.accrepceremp)
            );
            localStorage.setItem(
              "accfichacat",
              JSON.stringify(permisos.accfichacat)
            );
            localStorage.setItem(
              "accvalorterrecat",
              JSON.stringify(permisos.accvalorterrecat)
            );
            localStorage.setItem(
              "accdepreciacioncat",
              JSON.stringify(permisos.accdepreciacioncat)
            );
            localStorage.setItem(
              "accavaluo",
              JSON.stringify(permisos.accavaluo)
            );
            localStorage.setItem(
              "accusuariocat",
              JSON.stringify(permisos.accusuariocat)
            );
            localStorage.setItem(
              "accvalortipocat",
              JSON.stringify(permisos.accvalortipocat)
            );
          }
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El usuario " +
                response.data.iduser +
                " ha sido registrado de manera satisfactoria.",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El usuario " +
                response.data.iduser +
                " ha sido modificado de manera satisfactoria.",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El usuario " +
                response.data.iduser +
                " ha sido eliminado de manera satisfactoria.",
              icono: "exito",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const datosOrga = (idorganizacion) => {
    let campos = "*";
    let nomtab = "organizacion";
    let nomid = "idorganizacion";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idorganizacion}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setHabilitadoNU(true);
          if (response.data !== "") {
            txtNomOrg.current.value = response.data.nombre;
            txtCedula.current.focus();
            setContar(contar + 1);
          } else {
            txtNomOrg.current.value = "";
            txtIdOrg.current.value = "";
            setTitulo("Error");
            setMsg("La Organizacion no existe.");
            setContar(contar + 1);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.ingresa === 0) {
            txtNombreUsuario.current.value = "";
            txtApellidoUsuario.current.value = "";
            txtDireccionUsuario.current.value = "";
            txtEmailUsuario.current.value = "";
            txtTlfUsuario.current.value = "";
            txtCelUsuario.current.value = "";
            txtFechaNac.current.value = "";
            cmbNacionalidad.current.value = "V";
            cmbSexo.current.value = "M";
          }
          setHabilitadoNU(true);
          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreUsuario.current.value = response.data.nombres;
            txtApellidoUsuario.current.value = response.data.apellidos;
            txtDireccionUsuario.current.value = response.data.direccion;
            txtEmailUsuario.current.value = response.data.correoe;
            txtTlfUsuario.current.value = response.data.tlf1;
            txtCelUsuario.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment.utc(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreUsuario.current.focus();
              }, 100);
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const validarOrg = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        datosOrga(event.target.value);
      } else {
        txtNomOrg.current.value = "";
        txtIdOrg.current.value = "";
      }
    }
  };

  const handleCloseCatalogo = () => {
    setMostrar2(false);
  };

  const handleAceptaCatalogo = (idOrg, nomOrg) => {
    setMostrar2(false);
    txtIdOrg.current.value = idOrg;
    txtNomOrg.current.value = nomOrg;
  };

  const catalogoOrg = () => {
    setMostrar2(true);
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombreUsuario.current.value = nomPer;
    txtApellidoUsuario.current.value = apePer;
    txtDireccionUsuario.current.value = direPer;
    txtEmailUsuario.current.value = correoPer;
    txtTlfUsuario.current.value = tlf1Per;
    txtCelUsuario.current.value = tlf2Per;
    txtFechaNac.current.value = fnacPer;
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    btnAcepta.current.focus();
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };

  const blanquear = () => {
    setTitulo("");
    setMsg("");
    setModulos({
      accedocuenta: "0",
      accrenovalicencia: "0",
      acclicenciafunciona: "0",
      accpermdecla: "0",
      accacreditacion: "0",
      accexoncomercio: "0",
      accverifica: "0",
      accconfigcome: "0",
      accrepgensector: "0",
      accreppatente: "0",
      accrepactividad: "0",
      accrepfecdecla: "0",
      accrepmondecla: "0",
      accimppatente: "0",
      accimpedoctasectcome: "0",
      accimptramites: "0",
    });
    setPermisos({
      accvalortipocat: "0000",
      accfichacat: "0000",
      supercat: false,
      accavaluo: "0000",
      accdepreciacioncat: "0000",
      accvalorterrecat: "0000",
      accrepvalconstruc: "0000",
      accusuariocat: "0000",
      accactividad: "0000",
      accdeclaraciones: "000",
      accacticontri: "00",
      accagente: "0000",
      accusuariocome: "0000",
    });
  };
  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const handleChangeOtro = (event) => {
    setModulos({ ...modulos, [event.target.name]: event.target.value });
  };

  const handleChangeChek = (event) => {
    var num;
    num = event.target.checked === true ? "1" : "0";
    if (event.target.name === "accfichacat") {
      if (event.target.id === "chkRegContriConsul") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accfichacat.toString().substring(1, 2) +
            permisos.accfichacat.toString().substring(2, 3) +
            permisos.accfichacat.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkRegContriInc") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accfichacat.toString().substring(0, 1) +
            num +
            permisos.accfichacat.toString().substring(2, 3) +
            permisos.accfichacat.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkRegContriEdit") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accfichacat.toString().substring(0, 1) +
            permisos.accfichacat.toString().substring(1, 2) +
            num +
            permisos.accfichacat.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkRegContriElim") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accfichacat.toString().substring(0, 1) +
            permisos.accfichacat.toString().substring(1, 2) +
            permisos.accfichacat.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "chkRegContriTodo") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "1111" : "0000",
        });
      }
    } else if (event.target.name === "accvalortipocat") {
      if (event.target.id === "valoracion1") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accvalortipocat.toString().substring(1, 2) +
            permisos.accvalortipocat.toString().substring(2, 3) +
            permisos.accvalortipocat.toString().substring(3, 4),
        });
      } else if (event.target.id === "valoracion2") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accvalortipocat.toString().substring(0, 1) +
            num +
            permisos.accvalortipocat.toString().substring(2, 3) +
            permisos.accvalortipocat.toString().substring(3, 4),
        });
      } else if (event.target.id === "valoracion3") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accvalortipocat.toString().substring(0, 1) +
            permisos.accvalortipocat.toString().substring(1, 2) +
            num +
            permisos.accvalortipocat.toString().substring(3, 4),
        });
      } else if (event.target.id === "valoracion4") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accvalortipocat.toString().substring(0, 1) +
            permisos.accvalortipocat.toString().substring(1, 2) +
            permisos.accvalortipocat.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "valoracion5") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "1111" : "0000",
        });
      }
    } else if (event.target.name === "accvalorterrecat") {
      if (event.target.id === "tierra1") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accvalorterrecat.toString().substring(1, 2) +
            permisos.accvalorterrecat.toString().substring(2, 3) +
            permisos.accvalorterrecat.toString().substring(3, 4),
        });
      } else if (event.target.id === "tierra2") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accvalorterrecat.toString().substring(0, 1) +
            num +
            permisos.accvalorterrecat.toString().substring(2, 3) +
            permisos.accvalorterrecat.toString().substring(3, 4),
        });
      } else if (event.target.id === "tierra3") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accvalorterrecat.toString().substring(0, 1) +
            permisos.accvalorterrecat.toString().substring(1, 2) +
            num +
            permisos.accvalorterrecat.toString().substring(3, 4),
        });
      } else if (event.target.id === "tierra4") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accvalorterrecat.toString().substring(0, 1) +
            permisos.accvalorterrecat.toString().substring(1, 2) +
            permisos.accvalorterrecat.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "tierra5") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "1111" : "0000",
        });
      }
    } else if (event.target.name === "accdepreciacioncat") {
      if (event.target.id === "depre1") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accdepreciacioncat.toString().substring(1, 2) +
            permisos.accdepreciacioncat.toString().substring(2, 3) +
            permisos.accdepreciacioncat.toString().substring(3, 4),
        });
      } else if (event.target.id === "depre2") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accdepreciacioncat.toString().substring(0, 1) +
            num +
            permisos.accdepreciacioncat.toString().substring(2, 3) +
            permisos.accdepreciacioncat.toString().substring(3, 4),
        });
      } else if (event.target.id === "depre3") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accdepreciacioncat.toString().substring(0, 1) +
            permisos.accdepreciacioncat.toString().substring(1, 2) +
            num +
            permisos.accdepreciacioncat.toString().substring(3, 4),
        });
      } else if (event.target.id === "depre4") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accdepreciacioncat.toString().substring(0, 1) +
            permisos.accdepreciacioncat.toString().substring(1, 2) +
            permisos.accdepreciacioncat.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "depre5") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "1111" : "0000",
        });
      }
    } else if (event.target.name === "accavaluo") {
      if (event.target.id === "aval1") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accavaluo.toString().substring(1, 2) +
            permisos.accavaluo.toString().substring(2, 3) +
            permisos.accavaluo.toString().substring(3, 4),
        });
      } else if (event.target.id === "aval2") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accavaluo.toString().substring(0, 1) +
            num +
            permisos.accavaluo.toString().substring(2, 3) +
            permisos.accavaluo.toString().substring(3, 4),
        });
      } else if (event.target.id === "aval3") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accavaluo.toString().substring(0, 1) +
            permisos.accavaluo.toString().substring(1, 2) +
            num +
            permisos.accavaluo.toString().substring(3, 4),
        });
      } else if (event.target.id === "aval4") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accavaluo.toString().substring(0, 1) +
            permisos.accavaluo.toString().substring(1, 2) +
            permisos.accavaluo.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "aval5") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "1111" : "0000",
        });
      }
    } else if (event.target.name === "accusuariocat") {
      if (event.target.id === "user1") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accusuariocat.toString().substring(1, 2) +
            permisos.accusuariocat.toString().substring(2, 3) +
            permisos.accusuariocat.toString().substring(3, 4),
        });
      } else if (event.target.id === "user2") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accusuariocat.toString().substring(0, 1) +
            num +
            permisos.accusuariocat.toString().substring(2, 3) +
            permisos.accusuariocat.toString().substring(3, 4),
        });
      } else if (event.target.id === "user3") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accusuariocat.toString().substring(0, 1) +
            permisos.accusuariocat.toString().substring(1, 2) +
            num +
            permisos.accusuariocat.toString().substring(3, 4),
        });
      } else if (event.target.id === "user4") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accusuariocat.toString().substring(0, 1) +
            permisos.accusuariocat.toString().substring(1, 2) +
            permisos.accusuariocat.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "user5") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "1111" : "0000",
        });
      }
    } else if (event.target.name === "supercat") {
      setPermisos({
        ...permisos,
        [event.target.name]: num,
      });
    }
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputCodigo") {
        txtLogin.current.focus();
      } else if (event.target.id === "inputLogin") {
        txtPassword.current.focus();
      } else if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          txtPassword.current.focus();
        } else {
          txtConfirmPassword.current.focus();
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          txtConfirmPassword.current.focus();
        } else {
          txtIdOrg.current.focus();
        }
      } else if (event.target.id === "inputNomUsuario") {
        txtApellidoUsuario.current.focus();
      } else if (event.target.id === "inputApeUsuario") {
        txtDireccionUsuario.current.focus();
      } else if (event.target.id === "inputDireUsuario") {
        txtEmailUsuario.current.focus();
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de Email invalido.");
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtCelUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            event.target.value = "";
          } else {
            txtCelUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputCelUsuario") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            event.target.value = "";
          } else {
            txtFechaNac.current.focus();
          }
        }
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
        }
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de Email invalido.");
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtCelUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            event.target.value = "";
          } else {
            txtCelUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputCelUsuario") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            event.target.value = "";
          } else {
            txtFechaNac.current.focus();
          }
        }
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtLogin.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("El Usuario no debe estar vacio");
      sigue = false;
      txtLogin.current.focus();
    } else if (txtPassword.current.value.trim() === "" && operacion === 1) {
      setTitulo("Error");
      setMsg("La Contraseña no debe estar vacia");
      sigue = false;
      txtPassword.current.focus();
    } else if (
      txtConfirmPassword.current.value.trim() === "" &&
      operacion === 1
    ) {
      setTitulo("Error");
      setMsg("La Confirmación de la Contraseña no debe estar vacia");
      sigue = false;
      txtConfirmPassword.current.focus();
    } else if (
      txtPassword.current.value.trim() !==
        txtConfirmPassword.current.value.trim() &&
      operacion === 1
    ) {
      setTitulo("Error");
      setMsg("Las Contraseñas no coinciden");
      sigue = false;
      txtConfirmPassword.current.focus();
    } else if (txtIdOrg.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("El Código de la rganización no debe estar vacio");
      sigue = false;
      txtIdOrg.current.focus();
    } else if (txtNomOrg.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("El Nombre de la rganización no debe estar vacio");
      sigue = false;
      txtNomOrg.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("La cedula no debe estar vacia");
      sigue = false;
      txtCedula.current.focus();
    } else if (txtNombreUsuario.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("Los nombres no deben estar vacios");
      sigue = false;
      txtNombreUsuario.current.focus();
    } else if (txtApellidoUsuario.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("Los Apellidos no deben estar vacio");
      sigue = false;
      txtApellidoUsuario.current.focus();
    } else if (txtDireccionUsuario.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("La direccion del Usuario no debe estar vacia");
      sigue = false;
      txtDireccionUsuario.current.focus();
    } else if (txtFechaNac.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("La fecha de nacimiento no debe estar vacia");
      sigue = false;
      txtFechaNac.current.focus();
    }
    if (sigue) {
      var user = [];
      var datoPer = [];
      user.push({
        idusuario:
          txtIdUsuario.current.value === "" ? "0" : txtIdUsuario.current.value,
        login: txtLogin.current.value,
        passwd: txtPassword.current.value,
        idorganizacion: txtIdOrg.current.value,
        persona: txtCedula.current.value,
        accrepvalterreno: modulos.accrepvalterreno,
        accrepdepreciacion: modulos.accrepdepreciacion,
        clavesupercat:
          txtClaveSuper.current.value !== ""
            ? txtClaveSuper.current.value.trim()
            : "",
        accrepgenseccat: modulos.accrepgenseccat,
        accrepconstancia: modulos.accrepconstancia,
        accrepvalconstruc: modulos.accrepvalconstruc,
        acccamstainmue: modulos.acccamstainmue,
        accrepcedcat: modulos.accrepcedcat,
        accrepceremp: modulos.accrepceremp,
        accfichacat: permisos.accfichacat,
        accvalorterrecat: permisos.accvalorterrecat,
        accdepreciacioncat: permisos.accdepreciacioncat,
        accavaluo: permisos.accavaluo,
        accusuariocat: permisos.accusuariocat,
        supercat: chkLiquidador.current.checked,
        accvalortipocat: permisos.accvalortipocat,
      });
      datoPer.push({
        apellidos: txtApellidoUsuario.current.value.trim().toUpperCase(),
        cedula: txtCedula.current.value,
        correoe: txtEmailUsuario.current.value,
        direccion: txtDireccionUsuario.current.value.trim().toUpperCase(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreUsuario.current.value.trim().toUpperCase(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfUsuario.current.value,
        tlf2: txtCelUsuario.current.value,
      });
      let body = {
        operacionper: operacionPer,
        usu: JSON.stringify(user),
        perso: JSON.stringify(datoPer),
      };
      procesarRegistro(body);
    } else {
    }
  };

  const mostrarPassword = () => setMostrarClave(!mostrarClave);
  const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.render();
    blanquear();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setDeshabilitado(props.deshabilitado);
        if (props.usuario) {
          setModulos({
            accrepvalterreno:
              props.usuario.accrepvalterreno === null
                ? "0"
                : props.usuario.accrepvalterreno,
            accrepdepreciacion:
              props.usuario.accrepdepreciacion === null
                ? "0"
                : props.usuario.accrepdepreciacion,
            accrepgenseccat:
              props.usuario.accrepgenseccat === null
                ? "0"
                : props.usuario.accrepgenseccat,
            accrepconstancia:
              props.usuario.accrepconstancia === null
                ? "0"
                : props.usuario.accrepconstancia,
            accrepvalconstruc:
              props.usuario.accrepvalconstruc === null
                ? "0"
                : props.usuario.accrepvalconstruc,
            acccamstainmue:
              props.usuario.acccamstainmue === null
                ? "0"
                : props.usuario.acccamstainmue,
            accrepcedcat:
              props.usuario.accrepcedcat === null
                ? "0"
                : props.usuario.accrepcedcat,
            accrepceremp:
              props.usuario.accrepceremp === null
                ? "0"
                : props.usuario.accrepceremp,
          });
          setPermisos({
            accfichacat:
              props.usuario.accfichacat === null
                ? "0000"
                : props.usuario.accfichacat,
            accvalorterrecat:
              props.usuario.accvalorterrecat === null
                ? "000"
                : props.usuario.accvalorterrecat,
            accdepreciacioncat:
              props.usuario.accdepreciacioncat === null
                ? "00"
                : props.usuario.accdepreciacioncat,
            accavaluo:
              props.usuario.accavaluo === null
                ? "0000"
                : props.usuario.accavaluo,
            accusuariocat:
              props.usuario.accusuariocat === null
                ? "0000"
                : props.usuario.accusuariocat,
            supercat:
              props.usuario.supercat === null ? false : props.usuario.supercat,
            accvalortipocat:
              props.usuario.accvalortipocat === null
                ? "0000"
                : props.usuario.accvalortipocat,
          });
        } else {
          setModulos({
            accrepgenseccat: "0",
            accrepdepreciacion: "0",
            accrepvalterreno: "0",
            accrepvalconstruc: "0",
            accrepconstancia: "0",
            accrepceremp: "0",
            accrepcedcat: "0",
            acccamstainmue: "0",
            accedocuenta: "0",
            accrenovalicencia: "0",
            acclicenciafunciona: "0",
            accpermdecla: "0",
            accacreditacion: "0",
            accexoncomercio: "0",
            accverifica: "0",
            accconfigcome: "0",
            accrepgensector: "0",
            accreppatente: "0",
            accrepactividad: "0",
            accrepfecdecla: "0",
            accrepmondecla: "0",
            accimppatente: "0",
            accimpedoctasectcome: "0",
            accimptramites: "0",
          });
          setPermisos({
            accvalortipocat: "0000",
            accfichacat: "0000",
            supercat: false,
            accavaluo: "0000",
            accdepreciacioncat: "0000",
            accvalorterrecat: "0000",
            accrepvalconstruc: "0000",
            accusuariocat: "0000",
            accactividad: "0000",
            accdeclaraciones: "000",
            accacticontri: "00",
            accagente: "0000",
            accusuariocome: "0000",
          });
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 azulGradiant text-light d-flex justify-content-between">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Usuario."
            : operacion === 2
            ? "Editar Usuario."
            : operacion === 3
            ? "Eliminar Usuario."
            : "Consultar Usuario."}
        </h3>
        <a type="button" className="fw-bold text-light fs-6" ref={btnCancela} onClick={cancelar}>
          Salir <i className="fas fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div>
          <ul className="nav mb-2" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className=" rounded nav-link active bg-blue-100 text-light"
                id="datosTributarios2"
                data-bs-toggle="tab"
                data-bs-target="#tributarios2"
                type="button"
                role="tab"
                aria-controls="tributarios2"
                aria-selected="true"
              >
                Usuario
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className=" rounded nav-link bg-blue-200 text-light"
                id="deuda-tab2"
                data-bs-toggle="tab"
                data-bs-target="#deuda2"
                type="button"
                role="tab"
                aria-controls="deuda2"
                aria-selected="false"
              >
                Permisos de Aplicaciones
              </a>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="tributarios2"
              role="tabpanel"
              aria-labelledby="datosTributarios2"
            >
              {/* DATOS USUARIO */}

              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <div className="col-3 m-0 mb-2 p-0">
                  <Input
                    label="Código:"
                    disabled={true}
                    ref={txtIdUsuario}
                    defaultValue={props.usuario ? props.usuario.idusuario : ""}
                    id="inputCodigo"
                    onKeyUp={handleInputChange}
                  />
                </div>
                <div className="col-9 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Usuario:"
                    autocomplete="off"
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    ref={txtLogin}
                    defaultValue={props.usuario ? props.usuario.login : ""}
                    id="inputLogin"
                    onKeyUp={handleInputChange}
                  />
                </div>
                <div className="col-6 m-0 mb-2 p-0 d-flex">
                  <div className="col m-0 p-0">
                    <Input
                      label="Ingrese Contraseña:"
                      type={mostrarClave ? "text" : "password"}
                      disabled={
                        operacion === 4 || operacion === 2
                          ? true
                          : deshabilitado
                      }
                      ref={txtPassword}
                      id="inputPassword"
                      onKeyUp={handleInputChange}
                    />
                  </div>
                  <div className="col-auto m-0 p-0 input-group-sm">
                    <InfoButton
                      icon="fa-eye-slash m-0"
                      className="rounded-0"
                      disabled={
                        operacion === 4 || operacion === 2
                          ? true
                          : deshabilitado
                      }
                      onClick={mostrarPassword}
                    />
                  </div>
                </div>
                <div className="col-6 m-0 mb-2 p-0 pl-2 d-flex">
                  <div className="col m-0 p-0">
                    <Input
                      label="Confirmar Contraseña:"
                      type={mostrarClave1 ? "text" : "password"}
                      disabled={
                        operacion === 4 || operacion === 2
                          ? true
                          : deshabilitado
                      }
                      ref={txtConfirmPassword}
                      id="inputConfirmPassword"
                      onKeyUp={handleInputChange}
                    />
                  </div>
                  <div className="col-auto m-0 p-0 input-group-sm">
                    <InfoButton
                      icon="fa-eye-slash m-0"
                      className="rounded-0"
                      disabled={
                        operacion === 4 || operacion === 2
                          ? true
                          : deshabilitado
                      }
                      onClick={mostrarPassword1}
                    />
                  </div>
                </div>
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">Organización</legend>
                <div className="col-3 m-0 p-0">
                  <SearchInput
                    label="Código:"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtIdOrg}
                    id="inputIdOrg"
                    defaultValue={
                      props.usuario ? props.usuario.idorganizacion : ""
                    }
                    onKeyUp={validarOrg}
                    onBlur={validarOrg}
                    disabledButton={
                      operacion === 1 || operacion === 2 ? false : true
                    }
                    onClickButton={catalogoOrg}
                  />
                </div>
                <Input
                  disabled={true}
                  ref={txtNomOrg}
                  defaultValue={props.usuario ? props.usuario.razonsocial : ""}
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </fieldset>

              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">Datos Personales</legend>
                <div className="col-5 m-0 mb-2 p-0 d-flex">
                    <div className="col m-0 p-0">
                        <Select label = 'Cedula:'
                            disabled={!habilitadoNU}
                            ref={cmbNacionalidad}
                            defaultValue={
                            props.datospersonales
                                ? props.datospersonales.nacionalidad
                                : ""
                            }
                        >
                            <option key="0" value="V">
                            V
                            </option>
                            <option key="1" value="E">
                            E
                            </option>
                        </Select>
                    </div>
                    <div className="col-8 m-0 p-0">
                    <SearchInput 
                        disabled={operacion === 1 || operacion === 2 ? false : true}
                        ref={txtCedula}
                        id="inputCedula"
                        defaultValue={
                        props.datospersonales ? props.datospersonales.cedula : ""
                        }
                        onKeyUp={validarPersona}
                        onBlur={validarPersona}
                        disabledButton={ operacion === 1 || operacion === 2 ? false : true}
                        onClickButton={catalogoPer}
                    />
                    </div>
                </div>
                <div className="col-4 m-0 mb-2 ml-auto p-0">
                  <Input label = 'Fecha de Nacimiento:'
                    type="date"
                    disabled={!habilitadoNU}
                    ref={txtFechaNac}
                    id="inputFechaNac"
                    max={fechaSistema}
                    defaultValue={
                      props.datospersonales
                        ? moment.utc(props.datospersonales.fnacimiento).format(
                            "YYYY-MM-DD"
                          )
                        : ""
                    }
                    onKeyUp={handleInputChange}
                  />
                </div>
                <div className="col-6 m-0 mb-2 p-0">
                  <Input label = 'Nombres:'
                    disabled={!habilitadoNU}
                    ref={txtNombreUsuario}
                    id="inputNomUsuario"
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.nombres.trim()
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div className="col-6 m-0 mb-2 p-0 pl-2">
                  <Input label = 'Apellidos:'
                    disabled={!habilitadoNU}
                    ref={txtApellidoUsuario}
                    id="inputApeUsuario"
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.apellidos.trim()
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea label = 'Dirección:'
                    style={{ height: 70 }}
                    disabled={!habilitadoNU}
                    ref={txtDireccionUsuario}
                    id="inputDireUsuario"
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.direccion.trim()
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0">
                  <Input label = 'Correo:'
                    disabled={!habilitadoNU}
                    ref={txtEmailUsuario}
                    id="inputEmailUsuario"
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.correoe !== null
                          ? props.datospersonales.correoe.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0 pl-2">
                  <Input label = 'Telefono:'
                    disabled={!habilitadoNU}
                    ref={txtTlfUsuario}
                    id="inputTlfUsuario"
                    placeholder="0000-0000000"
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.tlf1 !== null
                          ? props.datospersonales.tlf1.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0 pl-2">
                  <Input label = 'Celular:'
                    disabled={!habilitadoNU}
                    ref={txtCelUsuario}
                    id="inputCelUsuario"
                    placeholder="0000-0000000"
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.tlf2 !== null
                          ? props.datospersonales.tlf2.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div className="col-2 m-0 p-0">
                  <Select label = 'Sexo:'
                    disabled={!habilitadoNU}
                    ref={cmbSexo}
                    defaultValue={
                      props.datospersonales ? props.datospersonales.sexo : ""
                    }
                  >
                    <option key="0" value="M">
                      M
                    </option>
                    <option key="1" value="F">
                      F
                    </option>
                  </Select>
                </div>
              </fieldset>
            </div>

            <div
              className="tab-pane fade"
              id="deuda2"
              role="tabpanel"
              aria-labelledby="deuda-tab2"
            >
              <ul className="nav mb-2" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <a
                    className=" rounded nav-link active bg-blue-100 text-light"
                    id="datosTributarios"
                    data-bs-toggle="tab"
                    data-bs-target="#tributarios"
                    type="button"
                    role="tab"
                    aria-controls="tributarios"
                    aria-selected="true"
                  >
                    Actualización
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className=" rounded nav-link bg-blue-200 text-light"
                    disabled={
                      operacion === 1 || operacion === 3 ? true : deshabilitado
                    }
                    id="deuda-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#deuda"
                    type="button"
                    role="tab"
                    aria-controls="deuda"
                    aria-selected="false"
                  >
                    Reportes
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className=" rounded nav-link bg-blue-300 text-light"
                    disabled={
                      operacion === 1 || operacion === 3 ? true : deshabilitado
                    }
                    id="hist-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#historico"
                    type="button"
                    role="tab"
                    aria-controls="historico"
                    aria-selected="false"
                  >
                    Usuarios
                  </a>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="tributarios"
                  role="tabpanel"
                  aria-labelledby="datosTributarios"
                >
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                      <span className="col m-0 p-0 fw-bold">Ficha Catastral:</span>
                      <div className="col-auto m-0 p-0 d-flex gap-2">
                        <Checkbox label = 'Consultar'
                          id="chkRegContriConsul"
                          name="accfichacat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accfichacat.toString().substring(0, 1) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Incluir'
                          id="chkRegContriInc"
                          name="accfichacat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accfichacat.toString().substring(1, 2) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Editar'
                          id="chkRegContriEdit"
                          name="accfichacat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accfichacat.toString().substring(2, 3) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Eliminar'
                          type="checkbox"
                          id="chkRegContriElim"
                          name="accfichacat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accfichacat.toString().substring(3, 4) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Todas'
                          id="chkRegContriTodo"
                          name="accfichacat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={permisos.accfichacat.toString() === "1111"}
                          onChange={handleChangeChek}
                        />
                      </div>
                    </div>
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                      <span className="col m-0 p-0 fw-bold"> Valoración de la Construcción:</span>
                      <div className="col-auto m-0 p-0 d-flex gap-2">
                        <Checkbox label = 'Consultar'
                          id="valoracion1"
                          name="accvalortipocat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accvalortipocat
                              .toString()
                              .substring(0, 1) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Incluir'
                          id="valoracion2"
                          name="accvalortipocat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accvalortipocat
                              .toString()
                              .substring(1, 2) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Editar'
                          id="valoracion3"
                          name="accvalortipocat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accvalortipocat
                              .toString()
                              .substring(2, 3) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Eliminar'
                          id="valoracion4"
                          name="accvalortipocat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accvalortipocat
                              .toString()
                              .substring(3, 4) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Todas'
                          id="valoracion5"
                          name="accvalortipocat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accvalortipocat.toString() === "1111"
                          }
                          onChange={handleChangeChek}
                        />
                      </div>
                    </div>
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                      <span className="col m-0 p-0 fw-bold">Valoración de la Tierra:</span>
                      <div className="col-auto m-0 p-0 d-flex gap-2">
                        <Checkbox label = 'Consultar'
                          id="tierra1"
                          name="accvalorterrecat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accvalorterrecat
                              .toString()
                              .substring(0, 1) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Incluir'
                          id="tierra2"
                          name="accvalorterrecat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accvalorterrecat
                              .toString()
                              .substring(1, 2) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Editar'
                          id="tierra3"
                          name="accvalorterrecat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accvalorterrecat
                              .toString()
                              .substring(2, 3) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Eliminar'
                          id="tierra4"
                          name="accvalorterrecat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accvalorterrecat
                              .toString()
                              .substring(3, 4) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Todas'
                          type="checkbox"
                          id="tierra5"
                          name="accvalorterrecat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accvalorterrecat.toString() === "1111"
                          }
                          onChange={handleChangeChek}
                        />
                      </div>
                    </div>
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                      <span className="col m-0 p-0 fw-bold"> Depreciación de Edificaciones:</span>
                      <div className="col=auto m-0 p-0 d-flex gap-2">
                        <Checkbox label = 'Consultar'
                          id="depre1"
                          name="accdepreciacioncat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accdepreciacioncat
                              .toString()
                              .substring(0, 1) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Incluir'
                          id="depre2"
                          name="accdepreciacioncat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accdepreciacioncat
                              .toString()
                              .substring(1, 2) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Editar'
                          id="depre3"
                          name="accdepreciacioncat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accdepreciacioncat
                              .toString()
                              .substring(2, 3) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Eliminar'
                          id="depre4"
                          name="accdepreciacioncat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accdepreciacioncat
                              .toString()
                              .substring(3, 4) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Todas'
                          id="depre5"
                          name="accdepreciacioncat"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accdepreciacioncat.toString() === "1111"
                          }
                          onChange={handleChangeChek}
                        />
                      </div>
                    </div>
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                      <span className="col m-0 p-0 fw-bold">Cambiar Status:</span>
                      <div className="col-auto m-0 p-0 d-flex gap-2">
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'Disponible'
                            name="acccamstainmue"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="inlineRadio1"
                            value={1}
                            checked={
                              modulos.acccamstainmue === "1" ? true : false
                            }
                            onChange={handleChangeOtro}
                          />
                        </div>
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'No disponible'
                            name="acccamstainmue"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="inlineRadio2"
                            value={0}
                            checked={
                              modulos.acccamstainmue === "0" ? true : false
                            }
                            onChange={handleChangeOtro}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 m-0 p-2 d-flex border rounded">
                      <span className="col m-0 p-0 fw-bold">Avaluos:</span>
                      <div className="col-auto m-0 p-0 d-flex gap-2">
                        <Checkbox label = 'Consultar'
                          id="aval1"
                          name="accavaluo"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accavaluo.toString().substring(0, 1) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Incluir'
                          id="aval2"
                          name="accavaluo"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accavaluo.toString().substring(1, 2) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Editar'
                          id="aval3"
                          name="accavaluo"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accavaluo.toString().substring(2, 3) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Eliminar'
                          id="aval4"
                          name="accavaluo"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={
                            permisos.accavaluo.toString().substring(3, 4) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Todas'
                          id="aval5"
                          name="accavaluo"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          checked={permisos.accavaluo.toString() === "1111"}
                          onChange={handleChangeChek}
                        />
                      </div>
                    </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="deuda"
                  role="tabpanel"
                  aria-labelledby="deuda-tab"
                >
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                      <span className="col m-0 p-0 fw-bold">Cédula Catastral:</span>
                      <div className="col-auto m-0 p-0 d-flex gap-2">
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'Disponible'
                            name="accrepcedcat"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepcedcat1"
                            value={1}
                            checked={modulos.accrepcedcat === "1"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'No disponible'
                            name="accrepcedcat"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepcedcat2"
                            value={0}
                            checked={modulos.accrepcedcat === "0"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                      <span className="col m-0 p-0 fw-bold">Certificado de Empadronamiento:</span>
                      <div className="col-auto m-0 p-0 d-flex gap-2">
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'Disponible'
                            name="accrepceremp"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepceremp1"
                            value={1}
                            checked={modulos.accrepceremp === "1"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'No disponible'
                            name="accrepceremp"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepceremp2"
                            value={0}
                            checked={modulos.accrepceremp === "0"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                      <span className="col m-0 p-0 fw-bold"> Constancia de no poseer Vivienda:</span>
                      <div className="col-auto m-0 p-0 d-flex gap-2">
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'Disponible'
                            name="accrepconstancia"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepconstancia1"
                            value={1}
                            checked={modulos.accrepconstancia === "1"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'No disponible'
                            name="accrepconstancia"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepconstancia2"
                            value={0}
                            checked={modulos.accrepconstancia === "0"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                      <span className="col m-0 p-0 fw-bold">Listado Gen. por Sector:</span>
                      <div className="col-auto m-0 p-0 d-flex gap-2">
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'Disponible'
                            name="accrepgenseccat"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepgenseccat1"
                            value={1}
                            checked={modulos.accrepgenseccat === "1"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'No disponible'
                            name="accrepgenseccat"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepgenseccat2"
                            value={0}
                            checked={modulos.accrepgenseccat === "0"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                      <span className="col m-0 p-0 fw-bold">Valoración de Construcción:</span>
                      <div className="col-auto m-0 p-0 d-flex gap-2">
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'Disponible'
                            name="accrepvalconstruc"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepvalconstruc1"
                            value={1}
                            checked={modulos.accrepvalconstruc === "1"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'No disponible'
                            name="accrepvalconstruc"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepvalconstruc2"
                            value={0}
                            checked={modulos.accrepvalconstruc === "0"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                      <span className="col m-0 p-0 fw-bold">Valoración de Terreno:</span>
                      <div className="col-auto m-0 p-0 d-flex gap-2">
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'Disponible'
                            name="accrepvalterreno"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepvalterreno1"
                            value={1}
                            checked={modulos.accrepvalterreno === "1"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'No disponible'
                            name="accrepvalterreno"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepvalterreno2"
                            value={0}
                            checked={modulos.accrepvalterreno === "0"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                      <div className="col m-0 p-0 fw-bold">
                        Depreciación de Edicaciones:
                      </div>
                      <div className="col-auto m-0 p-0 d-flex gap-2">
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'Disponible'
                            name="accrepdepreciacion"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepdepreciacion1"
                            value={1}
                            checked={modulos.accrepdepreciacion === "1"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                        <div className="col-auto m-0 p-0">
                          <Radio label = 'No disponible'
                            name="accrepdepreciacion"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            id="accrepdepreciacion2"
                            value={0}
                            checked={modulos.accrepdepreciacion === "0"}
                            onChange={handleChangeOtro}
                          />
                        </div>
                      </div>
                    </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="historico"
                  role="tabpanel"
                  aria-labelledby="hist-tab"
                >
                    <div className="col-12 m-0 mb-2 p-2 d-flex border rounded">
                        <span className="col m-0 p-0 fw-bold">Usuarios Catastro:</span>
                        <div className="col-auto m-0 p-0 d-flex gap-2">
                        <Checkbox label = 'Consultar'
                            id="user1"
                            name="accusuariocat"
                            disabled={
                            operacion === 1 || operacion === 2 ? false : true
                            }
                            checked={
                            permisos.accusuariocat
                                .toString()
                                .substring(0, 1) === "1"
                            }
                            onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Incluir'
                            id="user2"
                            name="accusuariocat"
                            disabled={
                            operacion === 1 || operacion === 2 ? false : true
                            }
                            checked={
                            permisos.accusuariocat
                                .toString()
                                .substring(1, 2) === "1"
                            }
                            onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Editar'
                            id="user3"
                            name="accusuariocat"
                            disabled={
                            operacion === 1 || operacion === 2 ? false : true
                            }
                            checked={
                            permisos.accusuariocat
                                .toString()
                                .substring(2, 3) === "1"
                            }
                            onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Eliminar'
                            type="checkbox"
                            id="user4"
                            name="accusuariocat"
                            disabled={
                            operacion === 1 || operacion === 2 ? false : true
                            }
                            checked={
                            permisos.accusuariocat
                                .toString()
                                .substring(3, 4) === "1"
                            }
                            onChange={handleChangeChek}
                        />
                        <Checkbox label = 'Todas'
                            id="user5"
                            name="accusuariocat"
                            disabled={
                            operacion === 1 || operacion === 2 ? false : true
                            }
                            checked={permisos.accusuariocat.toString() === "1111"}
                            onChange={handleChangeChek}
                        />
                        </div>
                    </div>
                    <div className="col-12 m-0 p-2 d-flex gap-2 justify-content-end border rounded">
                        <div className="col-auto m-0 p-0">
                            <Checkbox label = 'Supervisor'
                            id="chkRegContriConsul"
                            name="supercat"
                            disabled={
                                operacion === 1 || operacion === 2 ? false : true
                            }
                            ref={chkLiquidador}
                            defaultChecked={
                                props.usuario ? props.usuario.supercat : false
                            }
                            onChange={handleChangeChek}
                            />
                        </div>
                        <div className="col-4 m-0 p-0">
                            <Input label = 'Clave de Seguridad:'
                            defaultChecked={
                                props.usuario && props.usuario.clavesupercat
                                ? props.usuario.clavesupercat.trim()
                                : ""
                            }
                            ref={txtClaveSuper}
                            disabled={
                                (operacion === 1 || operacion === 2) &&
                                (!chkLiquidador.current ||
                                !chkLiquidador.current.checked)
                            }
                            />
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton ref={btnAcepta} onClick={onChangeValidar}>
          Aceptar
        </SuccessButton>
        <DangerButton ref={btnCancela} onClick={cancelar}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <CatalogoOrganizacion
        titulo={titulo}
        mensaje={msg}
        show={mostrar2}
        onHideCancelaCatOrg={handleCloseCatalogo}
        onHideAceptaCatOrg={handleAceptaCatalogo}
      />
      <CatalogoPersona
        titulo={titulo}
        mensaje={msg}
        show={mostrar3}
        onHideCancelaCatPer={handleCloseCatalogoPer}
        onHideAceptaCatPer={handleAceptaCatalogoPer}
      />
    </Modal>
  );
};
